export function getDocsUrl(suffix: string = '', supportLocal: boolean = true) {
  const env = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  let base: string;

  if (supportLocal) {
    if (env === 'localhost') {
      base = 'https://localhost:3011';
    } else if (
      typeof document !== 'undefined' &&
      document.location.hostname.startsWith('local.')
    ) {
      base = 'https://localhost:3011';
    } else {
      base = `https://docs${env}.getcartwheel.com`;
    }
  } else {
    base = `https://docs${env}.getcartwheel.com`;
  }

  if (!suffix) {
    return base;
  }

  return `${base}${suffix.startsWith('/') ? suffix : `/${suffix}`}`;
}
